import { useEffect, useState } from 'react';
import { api } from '../api/client.js';
import type { MeResponse } from '../api/types.js';

interface UseMe {
  state: 'loading' | 'authenticated' | 'unauthenticated' | 'error';
  me?: MeResponse;
  error?: Error;
}

/**
 * Loads the current user from /api/me on mount. Fires once per mount;
 * 401/403 means the CF Access cookie is missing — the browser will be
 * redirected to login when the SPA refreshes from Cloudflare Access.
 */
export function useMe(): UseMe {
  const [state, setState] = useState<UseMe>({ state: 'loading' });

  useEffect(() => {
    let cancelled = false;
    api
      .get<MeResponse>('/api/me')
      .then((me) => {
        if (cancelled) return;
        setState({ state: 'authenticated', me });
      })
      .catch((err: Error & { status?: number }) => {
        if (cancelled) return;
        if (err.status === 401 || err.status === 403) {
          setState({ state: 'unauthenticated', error: err });
        } else {
          setState({ state: 'error', error: err });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
